module.exports = __webpack_public_path__ + "img/gallery-pic03.841f4ed4.jpg";